import BasketItemEndPoint from "./BasketItemEndPoint.js";
import MutualSettlementEndPoint from "./MutualSettlementEndPoint";
import OrderEndPoint from "./OrderEndPoint";
import OpenGraphEndPoint from "./OpenGraphEndPoint";
import UsersEndPoint from "./UsersEndPoint";

class Api {
    constructor(client) {
        client.proxy = {
            host: "admin.bypost.ru",
            port: 443,
        };
        this.client = client;

        this.basket_item = new BasketItemEndPoint(this.client);
        this.mutual_settlement = new MutualSettlementEndPoint(this.client);
        this.order = new OrderEndPoint(this.client);
        this.od_data = new OpenGraphEndPoint(this.client);
        this.users = new UsersEndPoint(this.client);
    }
}

export default Api;
